module.exports = __webpack_public_path__ + "static/media/web_kio.c05399bd.gif";